import { IconButton, Tooltip, useBreakpointValue } from '@chakra-ui/react';
import { TbRewindBackward15, TbRewindForward30, TbRewindBackward10, TbRewindForward10 } from 'react-icons/tb';

interface SkipButtonProps {
  seconds: number;
  isBackward?: boolean;
  onClick: () => void;
  isDisabled?: boolean;
}

export const SkipButton = ({ 
  seconds, 
  isBackward = false, 
  onClick, 
  isDisabled = false 
}: SkipButtonProps) => {
  const iconSize = useBreakpointValue({ base: 18, md: 20 });
  const buttonSize = useBreakpointValue({ base: 'sm', md: 'md' });
  
  // Choose the appropriate icon based on the seconds value
  const getIcon = () => {
    if (isBackward) {
      return Math.abs(seconds) === 10 ? <TbRewindBackward10 size={iconSize} /> : <TbRewindBackward15 size={iconSize} />;
    } else {
      return Math.abs(seconds) === 10 ? <TbRewindForward10 size={iconSize} /> : <TbRewindForward30 size={iconSize} />;
    }
  };

  const label = `Skip ${isBackward ? 'backward' : 'forward'} ${Math.abs(seconds)} seconds`;

  return (
    <Tooltip label={label} hasArrow placement="top">
      <IconButton
        aria-label={label}
        icon={getIcon()}
        onClick={onClick}
        isDisabled={isDisabled}
        variant="ghost"
        colorScheme="gray"
        size={buttonSize}
        borderRadius="full"
        p={1}
        color="#404040"
        _hover={{
          transform: 'scale(1.05)',
          bg: 'rgba(0, 0, 0, 0.05)'
        }}
        _active={{
          transform: 'scale(0.95)'
        }}
        transition="all 0.2s"
      />
    </Tooltip>
  );
}; 